import React from "react";

export default function MacBar() {
  return (
    <div className="mac-bar" data-testid="mac-bar">
      <span className="mac-dot r" />
      <span className="mac-dot y" />
      <span className="mac-dot g" />
      <div style={{
        flex: 1, textAlign: "center", fontSize: 11, color: "var(--ink-dim)",
        letterSpacing: "0.08em", textTransform: "uppercase",
      }}>
        Players Health Assist
      </div>
      <div style={{ width: 42 }} />
    </div>
  );
}
